const ErrorPage = () => {
    return <>
    <img src="./public/images/1-10.webp" />

    </>
}

export default ErrorPage;